import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LocationContextType {
    locationStatus: 'idle' | 'loading' | 'error' | 'success';
    locationError: string | null;
    setLocationStatus: (status: 'idle' | 'loading' | 'error' | 'success') => void;
    setLocationError: (error: string | null) => void;
}

// Default values for SSR
const defaultContextValue: LocationContextType = {
    locationStatus: 'idle',
    locationError: null,
    setLocationStatus: () => {},
    setLocationError: () => {}
};

const LocationContext = createContext<LocationContextType>(defaultContextValue);

export const LocationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [locationStatus, setLocationStatus] = useState<'idle' | 'loading' | 'error' | 'success'>('idle');
    const [locationError, setLocationError] = useState<string | null>(null);

    return (
        <LocationContext.Provider value={{
            locationStatus,
            locationError,
            setLocationStatus,
            setLocationError
        }}>
            {children}
        </LocationContext.Provider>
    );
};

export const useLocation = () => {
    const context = useContext(LocationContext);
    // Return default values if context is not available (during SSR)
    return context || defaultContextValue;
};

export default LocationContext;